import evNavDefaultData from "@/data/eVNavDefaultData";
import OptimiserDefaultData from "@/data/optimiserDefaultData";
import { CalcVsType, type State } from "./store_types";

export const defaultState: State = {
      // Class object data.
      users: [],
      permissions: null,
      driver: undefined,
      userGeoIPData: undefined,
      fleet: undefined,
      chargers: [],
      trips: [],
      evModels: [],
      networkBranding: [],
      vehicles: [],
      managedContent: [],
      favLocations: [],
      bookings: [],
      nearbyController: undefined,
      // Ui viewing object data selections.
      selectedTrip: undefined,
      selectedVehicle: undefined,
      selectedCharger: undefined,
      selectedLocation: undefined,
      queuedTripForDelete: undefined,
      viewedFleetVehicle: undefined,
      tripsGroups: undefined,
      addressSearchHistory: [],
      selectedFavLocation: undefined,
      // async statuses.
      authStatus: undefined,
      updateImageStatus: undefined,
      deleteTripStatus: undefined,
      routePlanningStatus: undefined,
      tripSavingStatus: undefined,
      updatingUserStatus: undefined,
      vehicleSavingStatus: undefined,
      radarFetchingFlag: false,
      settingsSavingStatus: undefined,
      // Ui flags.
      settingsFetchingFlag: true,
      chargerFetchingFlag: true,
      userFetchingFlag: true,
      fleetFetchingFlag: true,
      tripFetchingFlag: true,
      checkingToken: true,
      authorizedFlag: false,
      routePlanningFlag: false,
      showLogin: true,
      mainDialogContent: undefined,
      secondaryDialogContent: undefined,
      tertiaryDialogContent: undefined,
      displayAllChargersAlongRoute: false,
      displayLongestStep: false,
      showPrivateACChargers: true,
      showPrivateDCChargers: true,
      showPublicACChargers: true,
      showPublicDCChargers: true,
      chargersSearchCriteria: undefined,
      vehiclesSearchCriteria: undefined,
      displayConnectedVehicles: false,
      pannedCenter: undefined,
      infoPanelAnimation: undefined,
      flyToPoint: undefined,
      displayedBookingId: undefined,
      errorToDisplay: undefined,
      // settings.
      settingsTableID: undefined,
      SOCMax: OptimiserDefaultData.SOCMax,
      SOCMin: OptimiserDefaultData.SOCMin,
      SOCAct: OptimiserDefaultData.SOCAct,
      SOCEnd: OptimiserDefaultData.SOCEnd,
      defaultHomeCostPerKWh: OptimiserDefaultData.kWhCostHome,
      defaultPublicCostPerKWh: OptimiserDefaultData.kWhCostPublic,
      defaultCostPerMinDC: OptimiserDefaultData.electricityCostPerMinPublic,
      networkSelectionOverride: undefined,
      dieselCostPerLitre: OptimiserDefaultData.dieselCostPerLitre,
      dieselKmPerLitre: OptimiserDefaultData.dieselKmPerLitre,
      extraWeight: undefined,
      perAnnumMaintenanceCurrentV: OptimiserDefaultData.perAnnumMaintenanceCurrentV,
      perAnnumMaintenanceEV: OptimiserDefaultData.perAnnumMaintenanceEV,
      petrolCostPerLitre: OptimiserDefaultData.petrolCostPerLitre,
      petrolKmPerLitre: OptimiserDefaultData.petrolKmPerLitre,
      relativeSpeed: OptimiserDefaultData.relativeSpeed,
      dieselRoadUserCharges: OptimiserDefaultData.roadUserCharges,
      petrolRoadUserCharges: 0,
      electricRoadUserCharges: OptimiserDefaultData.roadUserCharges,
      calcVs: CalcVsType.PETROL,
      acceleration: evNavDefaultData.AccelerationAdjustment,
      passengers: 0,
      electric_CO2_kg_per_kWh: OptimiserDefaultData.electric_CO2_kg_per_kWh,
      hydrogen_road_user_charges: OptimiserDefaultData.hydrogen_road_user_charges,
      hydrogen_cost_per_kg: OptimiserDefaultData.hydrogen_cost_per_kg,
      hydrogen_maintenance_per_annum: OptimiserDefaultData.hydrogen_maintenance_per_annum,
      hydrogen_CO2_kg_per_kg: OptimiserDefaultData.hydrogen_CO2_kg_per_kg,
      DSA_optimise_stops_warning: false,
      DSA_change_itinerary_warning: false,
      DSA_delete_vehicle_warning: false,
      DSA_multi_approve_deny_warning: false,
      savedChargers: [],
      DSA_error_types: [],
      approval_history: [],
      DSA_request_history_delete_confirmation: false
    }
